import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { applyMiddleware, createStore } from "redux";

import { Provider } from "react-redux";

import reduxthunk from "redux-thunk";

import rootReducer from "./redux/reducers";

import "./assets/boxicons-2.0.7/css/boxicons.min.css";
import "./assets/css/grid.css";
import "./assets/css/index.css";
import "./assets/css/theme.css";
import "./assets/css/globalImg.css";
import "react-toastify/dist/ReactToastify.css";

import { composeWithDevTools } from "redux-devtools-extension";
import App from "./App";

import { BrowserRouter } from "react-router-dom";

export const store = createStore(
  rootReducer,
  // applyMiddleware(reduxthunk)
  composeWithDevTools(applyMiddleware(reduxthunk))
);

document.title = "Greenpay Merchant";

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {" "}
          <App />
        </MuiPickersUtilsProvider>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
